import { useGetOGPUserInfo } from 'ogp/hooks';
import { hasAccessWithinPolicyGroup, PolicyGroups } from 'shared/utils/policy-controller';
import { BranchOfficeRole } from 'types/roles/BranchOfficeRole';

export const useIsOgpPlannerOrHigher = () => {
  const userQuery = useGetOGPUserInfo();

  const isOgpPlannerOrHigher =
    userQuery.data &&
    hasAccessWithinPolicyGroup(
      PolicyGroups.DEPARTMENT,
      userQuery.data.userInfo,
      BranchOfficeRole.PLANNER
    );
  return isOgpPlannerOrHigher ?? false;
};
